module.exports = __webpack_public_path__ + "static/media/pop-up-banner.1664c63f.jpg";